import { render, staticRenderFns } from "./RolesUpdate.vue?vue&type=template&id=dbbfae2c"
import script from "./RolesUpdate.vue?vue&type=script&lang=js"
export * from "./RolesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports